<template>
  <OmtLayoutContainer>
    <OmtRow mb="24px">
      <OmtTypography as="h1-bold"> Modelo de coparticipação </OmtTypography>
    </OmtRow>

    <OmtRow mb="24px">
      <OmtTypography as="p1"> Confira o modelo de coparticipação do seu plano: </OmtTypography>
    </OmtRow>

    <OmtRow gap="24px" stack>
      <OmtCard v-for="(item, index) in models" :key="index">
        <CFlex justify-content="space-between" align-items="center" mb="16px">
          <CFlex>
            <OmtIcons :name="item.icon" size="lg" mr="16px" />
            <OmtTypography as="h3-bold">{{ item.title }}</OmtTypography>
          </CFlex>
          <CBox @click="item.isOpen = !item.isOpen" cursor="pointer">
            <OmtIcons :name="item.isOpen ? 'chevron-up' : 'chevron-down'" />
          </CBox>
        </CFlex>
        <OmtDivider mb="0 !important" />
        <CCollapse :is-open="item.isOpen">
          <CGrid template-columns="repeat(5, 1fr)" my="16px">
            <OmtTypography color="var(--colors-light-primary-gray2)" as="p2" text-align="right" grid-column-start="4">
              Percentual
            </OmtTypography>
            <OmtTypography color="var(--colors-light-primary-gray2)" as="p2" text-align="right"> Limite </OmtTypography>
          </CGrid>

          <CGrid template-columns="repeat(5, 1fr)" v-for="(model, id) in item.data" :key="id">
            <OmtDivider v-if="id !== 0" grid-column-start="1" grid-column-end="6" />
            <OmtTypography as="p1" grid-column-start="1" grid-column-end="4">
              {{ model.label }}
            </OmtTypography>
            <OmtTypography as="h3-bold" grid-column-start="4" text-align="right" grid-column-end="5">
              {{ model.percentual }}
            </OmtTypography>
            <OmtTypography as="h3-bold" grid-column-start="5" text-align="right" grid-column-end="6">
              {{ model.limite }}
            </OmtTypography>
          </CGrid>
        </CCollapse>
      </OmtCard>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
export default {
  data() {
    return {
      models: [
        {
          title: "Reembolso",
          icon: "circle-dollar",
          isOpen: true,
          data: [
            {
              label: "Consultas Médicas",
              percentual: "20%",
              limite: "R$ 15,00"
            },
            {
              label: "Exames simples",
              percentual: "20%",
              limite: "R$ -"
            },
            {
              label: "Exames simples - Einstein",
              percentual: "20%",
              limite: "R$ -"
            },
            {
              label: "Terapias",
              percentual: "30%",
              limite: "R$ -"
            }
          ]
        },
        {
          title: "Rede Credenciada",
          icon: "stethoscope",
          isOpen: true,
          data: [
            {
              label: "Consultas Médicas",
              percentual: "20%",
              limite: "R$ 15,00"
            },
            {
              label: "Exames simples",
              percentual: "20%",
              limite: "R$ -"
            },
            {
              label: "Exames simples - Einstein",
              percentual: "20%",
              limite: "R$ -"
            },
            {
              label: "Terapias",
              percentual: "30%",
              limite: "R$ -"
            }
          ]
        }
      ]
    };
  },
  methods: {}
};
</script>
